import { Injectable } from '@angular/core';
import { BaseClient } from '../common/client/base.client';
import { SvcClients } from '../common/client/SvcClients';

@Injectable({
  providedIn: 'root',
})
export class UserClient extends BaseClient {
  constructor() {
    super();
  }

  getRoles(companyGroupCode: number) {    
      return this.get(
        SvcClients.AdminSvc,
        `User/GetRoles?companyGroupCode=${companyGroupCode}`
      );    
  }

  getCompanyGroupsForCurrentUser(queryValue?: string, portalCode?: string) {
    let url = `User/GetCompanyGroupsForUser`;
    const params: string[] = [];
    if (queryValue) {
      params.push(`queryValue=${encodeURIComponent(queryValue)}`);
    }
    if (portalCode) {
      params.push(`portalCode=${encodeURIComponent(portalCode)}`);
    }
    if (params.length) {
      url += `?${params.join('&')}`;
    }
    return this.get(SvcClients.AdminSvc, url);
  }

  getUsers(data: { RoleIDs: [], CompanyGroupCode: number }) {
    return this.post(
      SvcClients.AdminSvc,
      `User/GetUsers`,
      data
    );
  }
}


